import { render, staticRenderFns } from "./CouponValidator.vue?vue&type=template&id=5cfb07e6"
import script from "./CouponValidator.vue?vue&type=script&lang=js"
export * from "./CouponValidator.vue?vue&type=script&lang=js"
import style0 from "./CouponValidator.vue?vue&type=style&index=0&id=5cfb07e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports